import { createAsyncThunk } from '@reduxjs/toolkit';
import api from 'api';
import { PersonalDevelopmentPlan, StateTransitionRequest } from 'types/pdp';
import { API_PDP_STATE_TRANSITION } from 'constants/api';
import { generateURL } from 'helpers';

export const pdpStateTransition = createAsyncThunk<
  PersonalDevelopmentPlan,
  { id: number; data: StateTransitionRequest }
>('pdp/stateTransition', async ({ id, data }, { rejectWithValue }) =>
  api.axios
    .post(generateURL(API_PDP_STATE_TRANSITION, { id }), data)
    .then((res) => res.data)
    .catch((e) => rejectWithValue(e.response?.data)),
);
